export default __webpack_public_path__ + "assets/frenchpolynesia-flag.png";